export const CollectionsFeatureFirebase = {
    PROD: 'features-prod',
    DEV: 'features-dev',
  } as const;